import Link from 'next/link';
import { clsx } from 'clsx';

import { LinksCollectionStoryblok } from '@monoimin/sb-types';

import { Icons, SharedLink } from '@monoimin/atoms';

type NavigationProps = {
  links: Array<LinksCollectionStoryblok>;
  linkClassName?: string;
};

export const HeaderNavigation = ({ links, linkClassName }: NavigationProps) => {
  return (
    <nav className='hidden min-[1200px]:block'>
      <ul className='flex gap-15'>
        {links.map((item) => {
          const { mainLink, links, title, _uid } = item;

          if (mainLink?.url) {
            return (
              <li key={_uid}>
                <Link
                  href={mainLink.url}
                  className={clsx(
                    'hover:text-red-primary link_underline relative translate-y-0 border-none ring-blue-400 ring-offset-1 focus:outline-hidden focus-visible:ring-2',
                    linkClassName
                  )}
                >
                  {mainLink?.title}
                </Link>
              </li>
            );
          }

          if (Array.isArray(links) && links.length > 0) {
            return (
              <li key={_uid}>
                <div className='listbox group relative'>
                  <div className='flex items-center gap-1'>
                    <span>{title}</span>
                    <Icons
                      sizeClassName='w-5 h-5'
                      icon='dropdown'
                      className='group-hover:rotate-180 shrink-0'
                      isInteractive
                    />
                  </div>
                  <ul className='listbox__options hidden group-hover:grid'>
                    {links.map((item) => {
                      const { _uid, link } = item;

                      return (
                        <li key={_uid}>
                          <SharedLink
                            href={link?.url}
                            underline='off'
                            className='listbox__option'
                          >
                            {link?.title}
                          </SharedLink>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            );
          }

          return null;
        })}
      </ul>
    </nav>
  );
};
